function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-hot-toast';
import withStyles from 'isomorphic-style-loader/withStyles';
import isObject from 'lodash/isObject';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import App from 'modules/App';
import Link from 'components/Link';
import XIcon from 'svg/x.svg';
import styles from './Toast.pcss';
var _React_PureComponent;
class Toast extends (_React_PureComponent = React.PureComponent) {
    getText(text) {
        if (!text) {
            return null;
        }
        if (isObject(text)) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, text));
        }
        return text;
    }
    getHeader(text) {
        const { type } = this.props;
        return this.getText(text) || /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.toast.header[type]));
    }
    render() {
        const { type, toastItem, content, header } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.toast__wrapper, styles[`toast__wrapper--${type}`]),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.toast__contentWrapper,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.toast__header,
                            children: this.getHeader(header)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.toast__content,
                            children: this.getText(content)
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Link, {
                    to: "",
                    onClick: ()=>toast.dismiss(toastItem.id),
                    children: /*#__PURE__*/ _jsx(XIcon, {})
                })
            ]
        });
    }
}
_define_property(Toast, "propTypes", {
    type: PropTypes.string,
    toastItem: PropTypes.object,
    content: PropTypes.oneOfType([
        PropTypes.shape({
            id: PropTypes.string
        }),
        PropTypes.string
    ]),
    header: PropTypes.oneOfType([
        PropTypes.shape({
            id: PropTypes.string
        }),
        PropTypes.string
    ])
});
_define_property(Toast, "defaultProps", {
    type: 'information'
});
export default withStyles(styles)(Toast);
